import { Component } from 'preact'
import { CLASS } from './Base'
import i18n from '../../i18n'

class CTA extends Component {
  render() {
    const { children, onClick } = this.props

    return (
      <div class={`${CLASS}-cta`}>
        {children}

        <div class={`${CLASS}-cta-text`}>
          {i18n('DID_YOU_MAKE_THIS')}
        </div>
        <button onClick={onClick}>
          {i18n('LEAVE_REVIEW')}
        </button>
      </div>      
    )
  }
}

export default CTA